import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Input, Button, Layout, Typography, Alert, Result, Space, Flex } from 'antd'
import { ProfileOutlined, UserOutlined } from '@ant-design/icons';
import { LeftBar } from '../componentes/leftBar';
import StringMask from "string-mask";
import api from '../service/axios'
import { useToasts } from 'react-toast-notifications';


const DELIMITERS = [".", "-", "/"];
const CPF_MASK = "000.000.000-00";

const { Content } = Layout

function removeTrailingCharIfFound(str, chars) {
    let result = str;

    chars.forEach(c => {
        if (str[str.length - 1] === c) {
            result = str.slice(0, str.length - 1);
        }
    });

    return result;
}

function formatValue(str) {
    const unmaskedValue = str.replace(/[.\-\/]/g, "").trim();
    let mask = CPF_MASK;

    const formatted = StringMask.process(unmaskedValue, mask);
    return removeTrailingCharIfFound(formatted.result, DELIMITERS);
}


export const ConsultaProfissionalCtrl = (props) => {

    const [cpf, setCpf] = useState('')
    const [nome, setNome] = useState('')
    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [data, setData] = useState(undefined)

    async function consulta() {
        try {
            setLoading(true)
            const result = await api.post('consulta-profissional', { nome: nome, cpf: cpf })
            console.log(result.data)
            setData(result.data)
            if (result.data.length === 0) {
                addToast("Não foi localizado nenhum registro!", { appearance: 'error', autoDismiss: true });
            }
        } catch (erro) {
            addToast(erro.message, { appearance: 'error', autoDismiss: true });
        }
        setLoading(false)
    }


    function renderConsultar() {
        return <React.Fragment>
            <Flex gap={5} vertical>
                <Typography.Title level={3}>Consulta Registro Profissional</Typography.Title>
                <br />
                <Input placeholder='Nº do CPF' style={{ textAlign: 'center' }}
                    value={cpf}
                    onChange={event => {
                        setCpf(formatValue(event.target.value))
                    }} />
               <Flex justify='center'> ou</Flex>
                <Input placeholder='Nome do Profissional' style={{ textAlign: 'center' }}
                    value={nome}
                    onChange={event => {
                        setNome(event.target.value)
                    }} />

                <Button type="primary" style={{ marginTop: 15 }} loading={loading} block onClick={() => consulta()}>
                    Consultar
                </Button>

                {
                    data?.length === 0 && <Alert style={{ marginTop: 15 }} message="Não foi localizado nenhum registro para os dados informados." type="error" />
                }
            </Flex>
        </React.Fragment>
    }


    function renderResultado() {
        return <React.Fragment>
            <Result
                status="success"
                title="Profissional Localizado"
                subTitle={<div> </div>}
                extra={[
                    <Alert type='success' description={
                        <Space direction='vertical'>
                            <Space direction={'horizontal'}>
                                <ProfileOutlined />
                                <strong> {data[0].CRQ} </strong>
                            </Space>
                            <Space direction={'horizontal'}>
                                <UserOutlined />
                                <strong> {data[0].NOME} </strong>
                            </Space>
                        </Space>
                    }>

                    </Alert>,
                    <br />,
                    <Button key="buy" onClick={() => setData(undefined)}>Voltar</Button>
                ]}
            />
        </React.Fragment>
    }


    return <Flex>
        <div
            style={{
                justifyContent: 'center',
                padding: 24,
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>

            <div style={{
                display: 'flex', justifyContent: 'center', flexDirection: 'column',
                maxWidth: 500, alignItems: 'center'
            }}>
                {data?.length > 0 ? renderResultado() : renderConsultar()}
            </div>
        </div>
    </Flex>

}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default ConsultaProfissionalCtrl